import React, { useState } from 'react';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import { isRole } from 'src/helpers/permissions';
import { USER_ROLES } from 'src/common/constants';

interface ServiceRequestActionsProps {
  serviceRequest: any;
  onEditServiceRequest: () => void;
  onDeleteServiceRequest: () => void;
  onDownloadPdf: () => void;
  user: any;
  loading?: boolean;
}

const ServiceRequestActions = ({
  serviceRequest,
  onEditServiceRequest,
  onDeleteServiceRequest,
  onDownloadPdf,
  user,
  loading,
}: ServiceRequestActionsProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const canPerformActions = isRole(
    [USER_ROLES.PROPERTY_DEVELOPER, USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
    user
  );

  if (!canPerformActions) return null;

  return (
    <>
      <Button
        color="semantic"
        onClick={onEditServiceRequest}
        disabled={loading}
        label={<FontAwesomeIcon glyph="pencil" weight="light" />}
      />
      <Button
        color="semantic"
        onClick={() => setIsDeleteModalOpen(true)}
        disabled={loading}
        label={<FontAwesomeIcon glyph="trash" weight="light" />}
      />
      <Button
        color="semantic"
        onClick={onDownloadPdf}
        disabled={loading}
        label={<FontAwesomeIcon glyph="download" weight="light" />}
      />

      {isDeleteModalOpen && !loading && (
        <ConfirmationModal
          variant="danger"
          title={`Delete Request ${serviceRequest.ticketNumber ?? serviceRequest.ticketId}?`}
          confirmLabel="Yes, Delete Permanently"
          cancelLabel="Go Back"
          requireTypeToConfirm={true}
          confirmationWord="DELETE"
          message={
            <div>
              <p>
                You are about to <strong>permanently delete</strong> this
                service request.
              </p>
              <p style={{ marginTop: '8px' }}>
                This action will destroy all data associated with this ticket,
                including:
              </p>
              <ul
                style={{
                  textAlign: 'left',
                  display: 'inline-block',
                  marginTop: '8px',
                }}
              >
                <li>Communication logs and Notes</li>
                <li>Uploaded Photos and Documents</li>
                <li>Appointment history</li>
              </ul>
            </div>
          }
          warningMessage="This action cannot be undone. This ticket will vanish forever."
          onCancel={() => setIsDeleteModalOpen(false)}
          onConfirm={() => {
            onDeleteServiceRequest();
            setIsDeleteModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default ServiceRequestActions;